import * as types from './mutation-types'
import { getSchedulesQuery } from './queries.graphql'
import api from "@/modules/api";
import gqlClient from '@/modules/graphql'

const actions = {
  async getEmpSchedules({
    commit

  }, variables = {}) {
    if(!variables.storeId){
      return []
    }


    try {
      commit(types.GET_TASK_CARD_DATA_BEGIN)
      const {
        data: {
          data:{
            store:{
              tasks
            }
          }
        }
      } = await gqlClient.query({
        query     : getSchedulesQuery,
        variables : variables
      })

      commit(types.GET_TASK_CARD_DATA_SUCCESS, tasks)
    } catch (e) {
      commit(types.GET_TASK_CARD_DATA_ERROR, e)
    }
  },
  async sendTaskEmail({ commit }, { data } ) {
    try {
      commit(types.SEND_TASK_EMAIL_BEGIN)
      const{
        data: {
          message
        }
      } = await api.taskCard.sendEmail(data)
    
      commit(types.SEND_TASK_EMAIL_SUCCESS, message);
    } catch (error) {
      commit(types.SEND_TASK_EMAIL_ERROR, error)
    }
  }
}
    
export default actions